import usePageTitle from "hooks/usePageTitle";
import CampaignForm from "routes/campaign/CampaignForm";
import RecordIdCard from "routes/ui_sandbox/RecordIdCard";
import useRecordIdParam from "routes/ui_sandbox/useRecordIdParam";

const CampaignFormPage = () => {
  usePageTitle("Campaign Form");
  const { id, setId, clearId } = useRecordIdParam();

  return (
    <>
      <RecordIdCard
        label="Campaign ID"
        description="Leave empty to create a campaign, or load an id to edit one."
        id={id}
        onLoad={setId}
        onClear={clearId}
      />
      <CampaignForm
        key={id}
        campaignId={id}
        onSuccess={saved => setId(saved?.id ?? id)}
        onCancel={clearId}
      />
    </>
  );
};

export default CampaignFormPage;
